// extracted by mini-css-extract-plugin
export var alertComponent = "AlertComponent-module--alertComponent--295c2";
export var alertComponentBody = "AlertComponent-module--alertComponentBody--79772";
export var alertComponentClose = "AlertComponent-module--alertComponentClose--e0113";
export var alertComponentHeading = "AlertComponent-module--alertComponentHeading--8ba57";
export var alertComponentIcon = "AlertComponent-module--alertComponentIcon--7a88f";
export var alertComponentLink = "AlertComponent-module--alertComponentLink--b3f63";
export var alertComponentWrapper = "AlertComponent-module--alertComponentWrapper--f08d4";
export var alertHeading = "AlertComponent-module--alertHeading--8f8b7";
export var alertIcon = "AlertComponent-module--alertIcon--5935e";
export var danger = "AlertComponent-module--danger--39ce1";
export var info = "AlertComponent-module--info--9b78f";
export var noChildren = "AlertComponent-module--noChildren--dd8f3";
export var none = "AlertComponent-module--none--669c0";
export var success = "AlertComponent-module--success--bfaf4";
export var warning = "AlertComponent-module--warning--5039e";